<template>
  <Layout class="md:mt-32 lg:mt-16">
    <section class="flex flex-col gap-7 text-left">
      <div class="-mb-6 -mt-5 flex items-center justify-between">
        <h1 class="text-left text-2xl text-dark-blue">Sorry.</h1>
        <img
          class="mt-5"
          src="@/assets/highway-badge.svg"
          alt="Highway Badge"
        />
      </div>
      <p class="text-dark-gray">
        {{ content.message }}
        <a
          v-if="content.link"
          :href="content.link"
          target="_blank"
          class="cursor-pointer text-yellow-500 underline hover:opacity-80"
          >here</a
        >
        <span v-if="content.link">.</span>
      </p>
      <p class="text-xs text-body-color">
        {{ content.contact }}
        <a
          class="text-yellow-500 underline hover:text-yellow-600"
          href="mailto:security@highway.com"
          >security@highway.com</a
        >.
      </p>
    </section>
  </Layout>
</template>

<script setup>
const MESSAGES = {
  default: {
    message:
      'We’re unable to verify your personal information and cannot approve your access at this time.',
    link: null,
    contact:
      'If you believe this is an error, please contact Highway support at',
  },
  distanceAnomaly: {
    message:
      'We were unable to verify your identity. Highway requires each user to have their own individual user account. Do you need to add another user? Please have each user create their own Highway account',
    link: 'https://highway.com/verify-your-account',
    contact: 'For additional support, please contact',
  },
};
import { computed } from 'vue';
import { useStore } from 'vuex';
import Layout from '@/components/layouts/HoldingTankLayout.vue';

const store = useStore();

const latestInquiry = computed(() => store.getters['users/getLatestInquiry']);

const content = computed(() => {
  const tags = latestInquiry.value?.tags || [];
  return tags.includes('SESSION DISTANCE ANOMALY')
    ? MESSAGES.distanceAnomaly
    : MESSAGES.default;
});
</script>
